/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Primary_Group_LabelInputs */

const en_metadata_merge_primary_group_label = /** @type {(inputs: Metadata_Merge_Primary_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary Event Group`)
};

const fr_metadata_merge_primary_group_label = /** @type {(inputs: Metadata_Merge_Primary_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'événements principaux`)
};

const de_metadata_merge_primary_group_label = /** @type {(inputs: Metadata_Merge_Primary_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primäre Veranstaltungsgruppe`)
};

const it_metadata_merge_primary_group_label = /** @type {(inputs: Metadata_Merge_Primary_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo principale dell'evento`)
};

const ru_metadata_merge_primary_group_label = /** @type {(inputs: Metadata_Merge_Primary_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основная группа событий`)
};

const es_metadata_merge_primary_group_label = /** @type {(inputs: Metadata_Merge_Primary_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos primarios`)
};

const zh_cn2_metadata_merge_primary_group_label = /** @type {(inputs: Metadata_Merge_Primary_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要事件组`)
};

const ja_metadata_merge_primary_group_label = /** @type {(inputs: Metadata_Merge_Primary_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要イベントグループ`)
};

const hi_metadata_merge_primary_group_label = /** @type {(inputs: Metadata_Merge_Primary_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्राथमिक कार्यक्रम समूह`)
};

const pt_pt2_metadata_merge_primary_group_label = /** @type {(inputs: Metadata_Merge_Primary_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos Primários`)
};

/**
* | output |
* | --- |
* | "Primary Event Group" |
*
* @param {Metadata_Merge_Primary_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_primary_group_label = /** @type {((inputs?: Metadata_Merge_Primary_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Primary_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_primary_group_label(inputs)
	if (locale === "de") return de_metadata_merge_primary_group_label(inputs)
	if (locale === "it") return it_metadata_merge_primary_group_label(inputs)
	if (locale === "ru") return ru_metadata_merge_primary_group_label(inputs)
	if (locale === "es") return es_metadata_merge_primary_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_primary_group_label(inputs)
	if (locale === "ja") return ja_metadata_merge_primary_group_label(inputs)
	if (locale === "hi") return hi_metadata_merge_primary_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_primary_group_label(inputs)
	return en_metadata_merge_primary_group_label(inputs)
});